export const KARAOKE_TRACK_NUMBER = 32;
export const LAYOUT_TRACKS_BASE = 90;
